/**
* Contact Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the Contact Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'contact-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // Formatting Gravity Forms
      function formatForms() {
        const form = document.querySelectorAll( '.form-skin' );
        const btn = document.querySelectorAll( '.button' );
        const label = document.querySelectorAll( '.form-select form label' );
        const upload = document.querySelector( '.form-select form .ginput_container_fileupload' );

        // If multiple forms on one page, goes through and formats each submit button
        btn.forEach( function( el ) {
          if ( el.id != 'gform_submit_button_4' ) {
            el.classList.add( 'btn' );
            el.classList.add( 'btn-dark' );
          }
        } );

        // Goes through each label and removes the "(Required)" addition
        label.forEach( function( el ) {
          el.innerText = el.innerText.split( '(Required)' )[0];
        } );

        // Adds styling elements to the image upload field
        function setUpload() {
          // Checks if elements have already been prepended
          // (safety for gform_post_render function below to not create duplicate extra inputs)
          if ( !document.querySelector( '.file_name' ) ) {
            const input = document.createElement( 'input' );
            const span = document.createElement( 'span' );

            // Creating elements to be styled for image upload field and prepending them to the field
            input.classList.add( 'file_name' );
            input.setAttribute( 'placeholder', 'Choose a PDF File (max 1MB)' );
            input.setAttribute( 'readonly', true );
            span.classList.add( 'span_browse', 'bg-brand-dark-blue', 'text-brand-off-white', 'font-semibold', 'absolute', 'flex', 'items-center', 'justify-center' );
            span.innerText = 'Browse';
            upload.prepend( input );
            upload.prepend( span );

            // On file input change, update the value of the text input
            upload.addEventListener( 'change', function() {
              if ( upload.children[3].value.split( 'fakepath\\' )[1] ) {
                input.value = upload.children[3].value.split( 'fakepath\\' )[1];
              } else {
                input.value = '';
              }
            } );
          }
        }

        setUpload();
      }

      formatForms();

      // If there is an error after submitting the form, restyle the form correctly so that things remain consistent
      $( document ).on( 'gform_post_render', function() {
        if ( document.querySelector( '.gfield_validation_message' ) ) {
          console.log( 'validation' );
          formatForms();
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'contact-form', COMPONENT );
} )( app );
